import React, { Component } from 'react'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import Typography from '@material-ui/core/Typography'
import messages from 'components/Apps/SeaLiceMonitor/translate'
import * as SLHelper from 'helpers/seaLice'

class Breadcrumbs extends Component {
  getActiveViewText = () => {
    const {
      activeView,
      intl: { formatMessage },
    } = this.props
    const list = SLHelper.VIEW_FILTER_LIST

    for (const key in list) {
      if (list.hasOwnProperty(key) && list[key].id === activeView)
        return formatMessage(messages[list[key].name])
    }

    return ''
  }

  getActiveItem = () => {
    const { activeView } = this.props

    return activeView === SLHelper.LIST_VIEW_BARRIOS
      ? this.getActiveBarrioText()
      : this.getActiveSiteText()
  }

  getActiveSiteText = () => {
    const {
      activeSite,
      intl: { formatMessage },
    } = this.props
    const sitesData = this.props.sitesData.toArray()

    for (const key in sitesData) {
      if (
        sitesData.hasOwnProperty(key) &&
        sitesData[key].site_id === activeSite
      )
        return sitesData[key].site_name
    }

    return formatMessage(messages.allSites)
  }

  getActiveBarrioText = () => {
    const {
      activeBarrio,
      intl: { formatMessage },
    } = this.props
    const barriosList = this.props.barriosList.toArray()

    for (const key in barriosList) {
      if (
        barriosList.hasOwnProperty(key) &&
        barriosList[key].id === activeBarrio
      )
        return barriosList[key].name
    }

    return formatMessage(messages.allBarrios)
  }

  getActiveSpeciesText = () => {
    const { activeSpecies } = this.props
    const speciesList = this.props.speciesList.toArray()

    for (const key in speciesList) {
      if (
        speciesList.hasOwnProperty(key) &&
        speciesList[key].id === activeSpecies
      )
        return speciesList[key].name
    }

    return ''
  }

  getActiveTypeText = () => {
    const {
      activeType,
      intl: { formatMessage },
    } = this.props
    const list = SLHelper.TYPE_FILTER_LIST

    for (const key in list) {
      if (list.hasOwnProperty(key) && list[key].id === activeType)
        return formatMessage(messages[list[key].title])
    }

    return ''
  }

  render() {
    return (
      <Typography variant="subtitle1" className="table-breadcrumbs">
        {`${this.getActiveViewText()} / ${this.getActiveItem()} / ${this.getActiveSpeciesText()} / ${this.getActiveTypeText()}`}
      </Typography>
    )
  }
}

export default connect(state => ({
  activeView: state.getIn(['seaLice', 'activeView']),
  activeType: state.getIn(['seaLice', 'activeType']),
  barriosList: state.getIn(['seaLice', 'barriosList']),
  activeBarrio: state.getIn(['seaLice', 'activeBarrios']),
  sitesData: state.getIn(['seaLice', 'sitesData']),
  activeSite: state.getIn(['profile', 'siteId']),
  speciesList: state.getIn(['seaLice', 'speciesList']),
  activeSpecies: state.getIn(['seaLice', 'activeSpecies']),
}))(injectIntl(Breadcrumbs))
